
              var React = window.React;
              module.exports = {
                jsx: React.createElement,
                jsxs: React.createElement,
                jsxDEV: React.createElement,
                Fragment: React.Fragment,
              };
            